// extracted by mini-css-extract-plugin
module.exports = {"actionsOnGroups":"ActionsOnGroups_actionsOnGroups__LtIWT","select":"ActionsOnGroups_select__3iPjw","buttons":"ActionsOnGroups_buttons__KOUP8"};